// extracted by mini-css-extract-plugin
export default {"pagination":"input_pagination__7+7CU","page-link":"input_page-link__9J2T6","container":"input_container__1XP76","icon":"input_icon__NUbr9"};